<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInPC from '../components/pc';
    import SignInH5 from '../components/h5';
    import loadScript from '../../../uitl/load-script';
    export default {
        name: 'Index',
        components: {
            SignInPC,
            SignInH5
        },
        data() {
            return {};
        },
        mounted() {
            loadScript('https://hm.baidu.com/hm.js?001e5e9e10d733aa5b4d4d8dfcd24687');
            var _53code = document.createElement("script");
            _53code.src = "https://tb.53kf.com/code/code/90d3e270b5d355aa44bafe74fd7fe8a11/2";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(_53code, s);
        }
    };
</script>
<style>
    #mobile_minchat_div {
        display: none!important;
    }
    .app {
        overflow-x: hidden;
    }
</style>